.container {
  --left-right-padding: 16px;

  display: flex;
  flex-direction: column;
}

.title {
  font-size: var(--md-font-size);
  font-weight: 700;
  line-height: 22px;
  padding: 5px var(--left-right-padding);
}

.content {
  padding: 12px var(--left-right-padding);
  overflow-y: auto;
}

.divider {
  display: block;
  height: 1px;
  width: 100%;
  border-top: 1px solid var(--neutral-4-color);
}
